export class ModuleConfiguration {
  static moduleName = 'businessRule';
}



// WEBPACK FOOTER //
// ./src/app/businessRule/business-rule.module.config.ts